import React from 'react';
import { useApp } from '../context/AppContext';

function Privacy() {
  const { t } = useApp();

  return (
    <div className="min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold title-gradient mb-8">
          {t('privacy.title')}
        </h1>
        
        <div className="glass-effect rounded-lg p-8 space-y-6 text-text-light dark:text-text-dark">
          {/* Informações da Empresa */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.company.title')}
            </h2>
            <div className="space-y-2">
              <p><strong>{t('privacy.company.name')}:</strong> Thiago Henrique Silva Alves</p>
              <p><strong>{t('privacy.company.cnpj')}:</strong> 61.458.294/0001-94</p>
              <p><strong>{t('privacy.company.address')}:</strong> Rua Fernão Dias, 3804 - Belo Horizonte, MG - CEP 30285-160 - Brasil</p>
              <p><strong>{t('privacy.company.email')}:</strong> thiago@thz.dev.br</p>
              <p><strong>{t('privacy.company.phone')}:</strong> +55 (31) 98396-5539</p>
            </div>
          </section>

          {/* Coleta de Dados */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.collection.title')}
            </h2>
            <p className="mb-4">{t('privacy.collection.description')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('privacy.collection.items.0')}</li>
              <li>{t('privacy.collection.items.1')}</li>
              <li>{t('privacy.collection.items.2')}</li>
              <li>{t('privacy.collection.items.3')}</li>
            </ul>
          </section>

          {/* Uso dos Dados */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.usage.title')}
            </h2>
            <p className="mb-4">{t('privacy.usage.description')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('privacy.usage.items.0')}</li>
              <li>{t('privacy.usage.items.1')}</li>
              <li>{t('privacy.usage.items.2')}</li>
              <li>{t('privacy.usage.items.3')}</li>
            </ul>
          </section>

          {/* Compartilhamento de Dados */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.sharing.title')}
            </h2>
            <p>{t('privacy.sharing.description')}</p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.cookies.title')}
            </h2>
            <p>{t('privacy.cookies.description')}</p>
          </section>

          {/* Segurança */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.security.title')}
            </h2>
            <p>{t('privacy.security.description')}</p>
          </section>

          {/* Direitos do Usuário */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.rights.title')}
            </h2>
            <p className="mb-4">{t('privacy.rights.description')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('privacy.rights.items.0')}</li>
              <li>{t('privacy.rights.items.1')}</li>
              <li>{t('privacy.rights.items.2')}</li>
              <li>{t('privacy.rights.items.3')}</li>
              <li>{t('privacy.rights.items.4')}</li>
            </ul>
          </section>

          {/* LGPD */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.lgpd.title')}
            </h2>
            <p>{t('privacy.lgpd.description')}</p>
          </section>

          {/* Alterações */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.changes.title')}
            </h2>
            <p>{t('privacy.changes.description')}</p>
          </section>

          {/* Contato */}
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-primary-light dark:text-primary-dark">
              {t('privacy.contact.title')}
            </h2>
            <p>{t('privacy.contact.description')}</p>
          </section>

          <div className="pt-6 border-t border-gray-300 dark:border-gray-700">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {t('privacy.lastUpdate')}: {new Date().toLocaleDateString('pt-BR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
